import type { LatLngTuple } from 'leaflet';

const CURVE_BEND_RATIO = 0.25;
const CURVE_STEP_COUNT = 16;

function getBendPoint([fromLat, fromLng]: LatLngTuple, [toLat, toLng]: LatLngTuple): LatLngTuple {
  return [
    (fromLat + toLat) / 2 - (toLng - fromLng) * CURVE_BEND_RATIO,
    (fromLng + toLng) / 2 + (toLat - fromLat) * CURVE_BEND_RATIO,
  ];
}

function getCurvePoint(
  [fromLat, fromLng]: LatLngTuple,
  [bendLat, bendLng]: LatLngTuple,
  [toLat, toLng]: LatLngTuple,
  progress: number,
): LatLngTuple {
  const fromWeight = (1 - progress) ** 2;
  const bendWeight = 2 * (1 - progress) * progress;
  const toWeight = progress ** 2;
  return [
    fromLat * fromWeight + bendLat * bendWeight + toLat * toWeight,
    fromLng * fromWeight + bendLng * bendWeight + toLng * toWeight,
  ];
}

export function buildWalkingCurve(from: LatLngTuple, to: LatLngTuple): LatLngTuple[] {
  const bendPoint = getBendPoint(from, to);
  return Array.from({ length: CURVE_STEP_COUNT + 1 }, (_, stepIndex) =>
    getCurvePoint(from, bendPoint, to, stepIndex / CURVE_STEP_COUNT),
  );
}
